import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createQuestion as createQuestionApi,
  createQuestionSetApi,
  getQuestionPerSet,
  getQuestions,
  getQuestionSets,
} from "services/apiTrivia";

export function useQuestions() {
  const {
    isLoading,
    data: questions,
    error,
  } = useQuery({
    queryKey: ["questions"],
    queryFn: getQuestions,
  });

  return { isLoading, questions, error };
}

export function useCreateQuestionSet() {
  const queryClient = useQueryClient();

  const { mutate: createQuestionSet, isLoading: isCreating } = useMutation({
    mutationFn: createQuestionSetApi,
    onSuccess: () => {
      toast.success("New Question Set successfully created");
      queryClient.invalidateQueries({ queryKey: ["questionSets"] });
    },
    onError: (err) => toast.error(err.message),
  });

  return { isCreating, createQuestionSet };
}
export function useQuestionPerSet(id) {
  const {
    isLoading,
    data: questionsPerSet,
    error,
  } = useQuery({
    queryKey: ["questionsPerSet", { id }],
    queryFn: () => getQuestionPerSet(id),
  });

  return { isLoading, questionsPerSet, error };
}

export function useQuestionSets() {
  const {
    isLoading,
    data: questionSets,
    error,
  } = useQuery({
    queryKey: ["questionSets"],
    queryFn: getQuestionSets,
  });

  return { isLoading, questionSets, error };
}
export function useCreateQuestions() {
  const queryClient = useQueryClient();

  const { mutate: createQuestion, isLoading: isCreating } = useMutation({
    mutationFn: createQuestionApi,
    onSuccess: () => {
      toast.success("New question successfully created");
      queryClient.invalidateQueries({ queryKey: ["questions"] });
    },
    onError: (err) => toast.error(err.message),
  });

  return { isCreating, createQuestion };
}
